export class CvNotAvailable extends Error {
  constructor(message: string) {
    super(message);

    this.name = 'CvNotAvailable';
  }
}
